const hasLetters = (value) => /[a-zA-Z]/.test(value)

export default hasLetters
